import { TableColumnProps } from "../typings/global";
import {
  ScholarshipApplicationForm,
  ScholarshipApplicationDetailsProps,
} from "../typings/scholarship-applications";

export const SCHOLARSHIP_APPLICATION_INITIAL_VALUES: ScholarshipApplicationDetailsProps =
  {
    id: 0,
    name: "",
    cnic_number: "",
    gender: "",
    age: 0,
    residential_address: "",
    cell_phone: "",
    telephone: "",
    email: "",
    photo: "",
    educational_history: [],
    scholarship_request_details: {
      degree_discipline: "",
      degree_name: "",
      degree_institute: "",
      degree_semester: 1,
      degree_recognized_by: "",
      tuition_fee_per_semester: 0,
      admission_fee: 0,
      tuition_fee_per_semester_in_words: "",
      self_contribution_percentage: 0,
    },
    other_scholarships: [],
    guardian_details: {
      name: "",
      cnic_number: "",
      cell_phone: "",
      occupation: "",
      designation: "",
      employer: "",
      monthly_income: 0,
      pension: 0,
      family_members_count: 0,
    },
    studying_family_members: [],
    earning_family_members: [],
    accommodation_details: {
      accommodation_type: "",
      accommodation_ownership: "",
      accommodation_ownership_joint_or_independent: "",
      monthly_rent: 0,
    },
    family_liabilities: [],
    family_expenses: [],
    personal_statements: [],
    documents_attached: [],
    status: "",
    comments: [],
    rejection_reason: "",
    amount_paid_till_now: 0,
    amount_granted: 0,
    interviews: [],
    mentors: [],
    donors_tagged: [],
    is_resubmission_allowed: false,
    auto_evaluation_score: 0,
    is_special_case: false,
    social_participation_score: 0
  };

export const SCHOLARSHIP_APPLICATIONS_TABLE_COLUMNS: TableColumnProps[] = [
  { id: "id", label: "ID", minWidth: 100 },
  { id: "name", label: "Name", minWidth: 100 },
  { id: "email", label: "Email", minWidth: 200 },
  { id: "cell_phone", label: "Phone", minWidth: 100 },
  { id: "status", label: "Status", minWidth: 100 },
];

export const INSTITUTES = [
  "AIOU",
  "Abasyn University",
  "Aga Khan University",
  "Air University, Islamabad",
  "Allama Iqbal Open University",
  "Allama Iqbal Open University, Regional Campus Karachi",
  "Bacha Khan University",
  "Bacha Khan University, Charsadda",
  "Bahauddin Zakariya University",
  "Bahria University",
  "Balochistan University of Information Technology, Engineering and Management Sciences",
  "Baltistan University",
  "Bannu University",
  "Bannu University of Science and Technology",
  "Beaconhouse National University",
  "Benazir Bhutto Shaheed University of Technology and Skill Development",
  "Benazir Bhutto Shaheed University, Lyari",
  "Capital University of Science & Technology",
  "COMSATS University",
  "College of Physicians and Surgeons Pakistan",
  "Dean Foundation College",
  "Dow University of Health Sciences",
  "FATA University",
  "FATA University Timergara",
  "Fatima Jinnah Medical University",
  "Federal Urdu University of Arts, Science and Technology",
  "Forman Christian College",
  "Foundation University, Islamabad",
  "Gandhara University",
  "Gomal University",
  "Government College University, Dera Ismail Khan",
  "Government College University, Faisalabad",
  "Government College University, Hyderabad",
  "Government College University, Lahore",
  "Government Post Graduate College, Dera Ismail Khan",
  "Ghulam Ishaq Khan Institute of Engineering Sciences and Technology (GIKI)",
  "Hazara University",
  "Habib University (HU)",
  "Institute of Business Administration (IBA)",
  "Institute of Space Technology",
  "International Institute of Islamic Economics",
  "International Islamic University, Islamabad",
  "Islamia University of Bahawalpur",
  "Islamic University of Science & Technology, Awantipora",
  "Jinnah Sindh Medical University",
  "Jonah Medical and Dental College",
  "Karachi Institute of Technology and Entrepreneurship",
  "Karachi Institute of Economics and Technology (PAF-KIET)",
  "Karl University",
  "Karakoram International University",
  "Khushal Khan Khattak University",
  "Khushal Khan Khattak University, Karak",
  "King Edward Medical University",
  "Khyber Medical University",
  "Lahore School of Economics (LSE)",
  "Lahore University of Management Sciences (LUMS)",
  "Liaquat University of Medical and Health Sciences",
  "Mehran University of Engineering and Technology",
  "Muhammad Nawaz Sharif University of Engineering and Technology",
  "NED University of Engineering and Technology",
  "NFC Institute of Engineering and Fertilizer Research",
  "National College of Arts",
  "National College of Arts, Multan Campus",
  "National Defence University, Pakistan",
  "National Textile University",
  "FAST-NUCES (National University of Computer and Emerging Sciences)",
  "National University of Modern Languages",
  "National University of Sciences and Technology, Pakistan",
  "Nishtar Medical University",
  "Pakistan Institute of Engineering and Applied Sciences",
  "Pakistan Institute of Medical Sciences",
  "Police Line Technical College",
  "Punjab University",
  "Quaid-i-Azam University",
  "Quetta Institute of Medical Sciences",
  "Riphah International University",
  "Sardar Bahadur Khan Women's University",
  "Services Institute of Medical Sciences",
  "Shaheed Benazir Bhutto University",
  "Shaheed Benazir Bhutto University, Sheringal",
  "Shaheed Benazir Bhutto University, Shaheed Benazirabad",
  "Shaheed Benazir Bhutto Women University",
  "Shaheed Zulfiqar Ali Bhutto Medical University",
  "Shaheed Zulfiqar Ali Bhutto University of Veterinary and Animal Sciences",
  "Shifa Tameer-e-Millat University",
  "Sindh Madressatul Islam University",
  "Sir Syed CASE Institute of Technology",
  "Sir Syed University of Engineering and Technology (SSUET)",
  "SKCET",
  "Swat University",
  "The Islamia University of Bahawalpur",
  "University of Agriculture, Faisalabad",
  "University of Agriculture, Peshawar",
  "University of Azad Jammu and Kashmir",
  "University of Azad Jammu and Kashmir Bagh",
  "University of Balochistan",
  "University of Central Punjab",
  "University of Chitral",
  "University of Education, Lahore",
  "University of Engineering and Technology, Lahore",
  "University of Engineering and Technology, Peshawar",
  "University of Haripur",
  "University of Health Sciences",
  "University of Karachi (UOK)",
  "University of Kohat",
  "University of Kotli",
  "University of Lahore",
  "University of Management and Technology, Lahore",
  "University of Malakand",
  "University of Peshawar",
  "University of Sindh",
  "University of Swat",
  "University of Veterinary and Animal Sciences, Lahore",
  "Virtual University of Pakistan (VU)",
  "Women University Mardan",
  "Women University Swat",
];

export const SCHOLARSHIP_FORM_INITIAL_VALUES: ScholarshipApplicationForm = {
  name: "",
  cnic_number: "",
  gender: "",
  age: 0,
  residential_address: "",
  cell_phone: "",
  telephone: "",
  email: "",
  photo: "",
  educational_history: [
    {
      institute: "",
      score_is_percentage: false,
      score: 0,
      is_secondary_school: false,
      is_higher_school: false,
      is_university: true,
      current_semester: 1,
      total_semesters: 8,
    },
    {
      institute: "",
      score_is_percentage: true,
      score: 0,
      is_secondary_school: false,
      is_higher_school: true,
      is_university: false,
    },
    {
      institute: "",
      score_is_percentage: true,
      score: 0,
      is_secondary_school: true,
      is_higher_school: false,
      is_university: false,
    },
    
  ],
  scholarship_request_details: {
    degree_discipline: "",
    degree_name: "",
    degree_institute: "",
    degree_semester: 1,
    degree_recognized_by: "",
    tuition_fee_per_semester: 0,
    admission_fee: 0,
    tuition_fee_per_semester_in_words: "",
    self_contribution_percentage: 0,
  },
  other_scholarships: [],
  guardian_details: {
    name: "",
    cnic_number: "",
    cell_phone: "",
    occupation: "",
    designation: "",
    employer: "",
    monthly_income: 0,
    pension: 0,
    family_members_count: 0,
  },
  studying_family_members: [],
  earning_family_members: [],
  accommodation_details: {
    accommodation_type: "",
    accommodation_ownership: "",
    accommodation_ownership_joint_or_independent: "",
    monthly_rent: 0,
  },
  family_liabilities: [],
  family_expenses: [],
  personal_statements: [
    {
      question: "What are your career goals after graduation?",
      response: "",
    },
    {
      question: "Where do you see yourself ten years from now?",
      response: "",
    },
    {
      question: "List your major achievements to date.",
      response: "",
    },
    {
      question: "What motivated you to choose this college/university?",
      response: "",
    },
    {
      question: "Why do you think you deserve this scholarship?",
      response: "",
    },
  ],
  documents_attached: [
    { title: "Fee Voucher", attachment_url: [] },
    {
      title: "Last Paid Fee voucher (Proof of Fee payment)",
      attachment_url: [],
    },
    { title: "Your CNIC / B Form", attachment_url: [] },
    { title: "Guardian's CNIC", attachment_url: [] },
    {
      title:
        "Latest Record of Results (CGPA) and marksheets of all past examinations",
      attachment_url: [],
    },
    { title: "Passport size photograph", attachment_url: [] },
    { title: "Copy of university card", attachment_url: [] },
    { title: "Admission Letter", attachment_url: [] },
    { title: "Proof of household income", attachment_url: [] },
  ],
};

export const RELATIONS = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Husband",
  "Wife",
];
